export default __webpack_public_path__ + "static/media/awaiting3S.376bd7f7.svg";